import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as projects from '../../projects'

export const RESOURCE = {
  payload: {
    description:
      'A funded research initiative funded under an award, with specific objectives, personnel, and financial oversight that occurs over a period of time.',
    dimension: projects.RESOURCE.payload,
    level: 0,
    name: 'Project',
    partialId: PartialId.Standard.create('proj'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
